// Email checks used by the public forms: format validation plus a
// "did you mean" suggestion for common misspelled email providers.

const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

const COMMON_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "icloud.com",
  "aol.com",
  "msn.com",
  "ymail.com",
  "protonmail.com",
  "proton.me",
  "gmx.com",
  "mail.com",
  "zoho.com",
  "yandex.com",
];

const editDistance = (a, b) => {
  const dp = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1,
        dp[i][j - 1] + 1,
        dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
      );
    }
  }
  return dp[a.length][b.length];
};

// Returns { error, suggestion }. `error` is set for invalid emails;
// `suggestion` is a corrected email when the domain looks like a typo.
const checkEmail = (value) => {
  const email = (value || "").trim();
  if (!email) return { error: "Email is required", suggestion: null };
  if (!EMAIL_PATTERN.test(email)) {
    return { error: "Please enter a valid email address (e.g. name@gmail.com)", suggestion: null };
  }

  const [local, domain] = email.toLowerCase().split("@");
  if (COMMON_DOMAINS.includes(domain)) return { error: null, suggestion: null };

  const tld = domain.slice(domain.lastIndexOf("."));
  let best = null;
  COMMON_DOMAINS.forEach((candidate) => {
    const distance = editDistance(domain, candidate);
    // Allow a bigger difference when the start and the ending match (gmamam.com -> gmail.com)
    const similar =
      distance <= 2 ||
      (distance === 3 && domain.slice(0, 2) === candidate.slice(0, 2) && candidate.endsWith(tld));
    if (similar && (!best || distance < best.distance)) {
      best = { candidate, distance };
    }
  });

  return {
    error: null,
    suggestion: best ? `${local}@${best.candidate}` : null,
  };
};

export { checkEmail };
